module.exports = __webpack_public_path__ + "static/media/popai_ai.0a96a667.png";